<div class="dev-team__slider">
  <div class="dev-team__arrows">
    <span class="dev-team__arrow dev-team__arrow_left">&lt;</span>
    <span class="dev-team__delimiter">&#47;</span>
    <span class="dev-team__arrow dev-team__arrow_right">&gt;</span>
  </div>
  <div class="dev-team__content">
    <span class="dev-team__name">Daniil Shlemov</span>
    <span class="dev-team__github">
      <a href="https://github.com/uaolmer">Ссылка на гитхаб</a>
    </span>
  </div>
  <div class="dev-team__background"></div>
</div>
<div class="dev-team__heading">
  <span class="dev-team__title">Development Team</span>
  <span app-footer-credentials></span>
</div>
